<template>
  <v-app class="app">
    <v-system-bar
      :height="height"
      color="accent"
      class="darken-1 d-flex flex-column justify-center flex-lg-row"
      dark
      app
    >
      <ticker></ticker>
    </v-system-bar>
    <alert-banner></alert-banner>
    <v-system-bar
      v-if="showOverdueInvoiceRibbon"
      color="#CB6D51"
      class="d-flex justify-center overdue-invoice-ribbon"
      dark
      app
      :style="`top: ${overdueRibbonTop}px !important;`"
    >
      <span class="text-no-wrap">
        You have {{ getOverdueInvoiceCount }} overdue invoice{{ getOverdueInvoiceCount === 1 ? '' : 's' }} requiring attention.
      </span>
      <v-btn text small color="white" class="ml-2" to="/orders/invoices">
        View & Pay Invoices
      </v-btn>
    </v-system-bar>
    <app-toolbar class="app--toolbar" />
    <v-navigation-drawer
      clipped
      app
      v-if="$route.meta.showCatalogNav"
      width="356"
      :style="'top: ' + top + 'px; max-height: calc(100% - ' + top + 'px);'"
    >
      <catalog-filters></catalog-filters>
    </v-navigation-drawer>
    <v-main :style="'padding-top: ' + top + 'px'">
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <keep-alive :include="['Orders', 'KeepAliveRouteWrapper']">
          <!--<v-slide-x-transition mode="out-in">
            <router-view :key="routeKey"></router-view>
          </v-slide-x-transition>-->
          <transition :name="$route.meta.transitionName || 'v-fade-transition'">
            <router-view
              v-if="!$route.meta.bypassRouterKey"
              :key="routeKey"
            ></router-view>
            <router-view v-else></router-view>
          </transition>
        </keep-alive>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import AppToolbar from '@/components/AppToolbar'
import Ticker from '@/components/ticker/Ticker'
import CatalogFilters from '@/components/catalog/CatalogFilters'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import AlertBanner from '@/components/AlertBanner'
import featureFlagsMixin from '@/mixins/featureFlags'

export default {
  name: 'LayoutDefault',
  mixins: [featureFlagsMixin],
  components: {
    AlertBanner,
    CatalogFilters,
    AppToolbar,
    Ticker,
  },
  data() {
    return {
      online: true,
    }
  },
  watch: {
    'getSelectedCompany.id': {
      handler() {
        this.refreshOverdueInvoiceRibbon()
      },
    },
    '$route.fullPath': {
      handler() {
        this.refreshOverdueInvoiceRibbon()
      },
    },
  },
  computed: {
    ...mapGetters(['getSelectedCompany', 'getConfig', 'getOverdueInvoiceCount']),
    isPayNowEnabled() {
      return this.featureFlags.PAY_NOW_ENABLED
    },
    routeKey() {
      return `${this.$route.fullPath}_${_.get(
        this,
        'getSelectedCompany.id',
        ''
      )}`
    },
    alertBannerHeight() {
      return this.getConfig('ALERT_BANNER_ENABLED') ? 24 : 0
    },
    showOverdueInvoiceRibbon() {
      return this.isPayNowEnabled && this.getOverdueInvoiceCount > 0
    },
    overdueRibbonHeight() {
      return this.showOverdueInvoiceRibbon ? 24 : 0
    },
    overdueRibbonTop() {
      return this.height + this.alertBannerHeight
    },
    top() {
      return this.height + 64 + this.alertBannerHeight + this.overdueRibbonHeight
    },
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
        case 'md':
          return true
        default:
          return false
      }
    },
    height() {
      return 24 // Match AlertBanner height
    },
  },
  methods: {
    async refreshOverdueInvoiceRibbon() {
      if (!this.online || !_.get(this, 'getSelectedCompany.id')) return
      if (!this.isPayNowEnabled) return
      try {
        await this.$store.dispatch('fetchOverdueInvoiceCount')
      } catch (error) {
        // Optional UI signal; fail silently to avoid noisy global errors.
      }
    },
  },
  created() {
    window._VMA.$on('AUTH_FAILED', () => {
      this.online = false
    })
    window._VMA.$on('LOGOUT', () => {
      this.online = false
    })
  },
  async mounted() {
    await this.refreshOverdueInvoiceRibbon()
  },
}
</script>

<style lang="sass">
/*.page-wrapper
  min-height: calc(100vh - 112px - 48px)*/

.overdue-invoice-ribbon
  min-height: 24px
</style>
